import { memo } from 'react';

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import { CONTENT_MAX_WIDTH } from '@constants/layout';

/**
 * Consistent page content frame — max width, 8px-based padding.
 */
const PageShell = memo(function PageShell({ children, maxWidth = CONTENT_MAX_WIDTH, sx }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth,
        mx: 'auto',
        px: { xs: 2, sm: 3, lg: 4 },
        py: { xs: 3, md: 4 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
});

PageShell.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
};

export default PageShell;
